import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import lancarRelatorioBNCCSemestralPage from "@/Pages/Relatorios/lancarRelatorioBNCCSemestralPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";
import DiarioAeeListarTurmaPage from "@/Pages/Relatorios/ListarDiarioCAeeTurmaPage.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCCSemestral/:matricula_id",
    name: "relatorios.lancarRelatorioBNCCSemestral",
    component: lancarRelatorioBNCCSemestralPage,
  },
  {
    path: "/diario-caee/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizarDiarioCAee",
    component: DiarioAeeListarTurmaPage,
    beforeEnter(to, from, next) {
      if (!can(["gestoesDeAulasCAEE.visualizar", "gestoesDeAulasCAEE.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
